export default (fn: () => Promise<void>, lastTimerId: any, delay: number) => {
  const runCall = () => {
    fn();
  };
  if (lastTimerId) {
    clearTimeout(lastTimerId);
  }
  if (delay) {
    return setTimeout(runCall, delay);
  } else {
    runCall();
    return 0;
  }
};
